<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<span style="text-align:right">{{
    fieldDefinition.format
        ? (rowData[fieldDefinition.name] | number: fieldDefinition.format)
        : (rowData[fieldDefinition.name] | number: '1.0')
}}</span>
